import { alpha, Theme } from '@mui/material/styles';

export const MOBILE_FOOTER_HEIGHT = 68;
export const MOBILE_FOOTER_FAB_SIZE = 64;
/** Quanto o botão central sobe em relação à base da barra (~30% do tamanho) */
export const MOBILE_FOOTER_FAB_LIFT = MOBILE_FOOTER_FAB_SIZE * 0.3;
/** Espaço inferior do conteúdo (unidades MUI) para não cobrir o menu flutuante */
export const MOBILE_FOOTER_CONTENT_PB = 12;

export function getMobileFooterShellSx(theme: Theme, isDark: boolean) {
  return {
    position: 'fixed' as const,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: theme.zIndex.appBar,
    pb: 'env(safe-area-inset-bottom, 0px)',
    pointerEvents: 'none' as const,
  };
}

export function getMobileFooterBarSx(theme: Theme, isDark: boolean) {
  const primary = theme.palette.primary.main;

  return {
    pointerEvents: 'auto' as const,
    mx: 1.25,
    mb: 0,
    borderRadius: '20px 20px 0 0',
    minHeight: MOBILE_FOOTER_HEIGHT,
    px: 0.5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative' as const,
    overflow: 'visible',
    border: `1px solid ${isDark ? alpha('#3b82f6', 0.2) : alpha(primary, 0.12)}`,
    borderBottom: 'none',
    background: isDark
      ? alpha('#0a101f', 0.92)
      : alpha(theme.palette.background.paper, 0.92),
    backdropFilter: 'blur(16px)',
    WebkitBackdropFilter: 'blur(16px)',
    boxShadow: isDark
      ? `0 -4px 24px ${alpha('#000', 0.35)}, inset 0 1px 0 ${alpha('#fff', 0.06)}`
      : `0 8px 32px ${alpha('#0f172a', 0.12)}, 0 2px 8px ${alpha('#0f172a', 0.06)}`,
  };
}

export function getMobileFooterSideSx() {
  return {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minWidth: 0,
    '&:first-of-type': { justifyContent: 'flex-end', pr: 0.5 },
    '&:last-of-type': { justifyContent: 'flex-start', pl: 0.5 },
  };
}

export function getMobileFooterNavButtonSx(
  theme: Theme,
  isDark: boolean,
  active: boolean,
  disabled: boolean,
) {
  const primary = theme.palette.primary.main;

  return {
    flex: 1,
    minWidth: 0,
    maxWidth: 76,
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.35,
    py: 0.75,
    px: 0.25,
    border: 'none',
    borderRadius: 2.5,
    cursor: disabled ? 'default' : 'pointer',
    opacity: disabled ? 0.38 : 1,
    bgcolor: 'transparent',
    color: active
      ? isDark
        ? '#93c5fd'
        : primary
      : isDark
        ? alpha('#e2e8f0', 0.65)
        : theme.palette.text.secondary,
    transition: theme.transitions.create(['color', 'transform'], { duration: 180 }),
    '&:active': disabled
      ? {}
      : {
          transform: 'scale(0.94)',
        },
    '& .nav-icon-wrap': {
      width: 36,
      height: 36,
      borderRadius: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: theme.transitions.create('background-color', { duration: 180 }),
      bgcolor: active
        ? isDark
          ? alpha('#3b82f6', 0.22)
          : alpha(primary, 0.12)
        : 'transparent',
    },
    '& .nav-label': {
      fontSize: '0.625rem',
      fontWeight: active ? 700 : 500,
      lineHeight: 1.1,
      letterSpacing: 0.2,
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap' as const,
    },
  };
}

export function getMobileFooterFabSx(
  theme: Theme,
  isDark: boolean,
  active: boolean,
) {
  const primary = theme.palette.primary.main;

  return {
    pointerEvents: 'auto' as const,
    position: 'absolute' as const,
    bottom: MOBILE_FOOTER_FAB_LIFT,
    left: '50%',
    transform: 'translateX(-50%)',
    width: MOBILE_FOOTER_FAB_SIZE,
    height: MOBILE_FOOTER_FAB_SIZE,
    borderRadius: '50%',
    border: `4px solid ${
      isDark
        ? alpha('#0a101f', 0.95)
        : alpha(theme.palette.background.paper, 0.95)
    }`,
    background: active
      ? `linear-gradient(145deg, ${primary} 0%, ${theme.palette.primary.dark} 100%)`
      : isDark
        ? `linear-gradient(145deg, ${alpha('#3b82f6', 0.9)} 0%, ${alpha('#2563eb', 0.95)} 100%)`
        : `linear-gradient(145deg, ${primary} 0%, ${theme.palette.primary.dark} 100%)`,
    color: '#fff',
    boxShadow: active
      ? `0 8px 24px ${alpha(primary, 0.45)}`
      : isDark
        ? `0 6px 20px ${alpha('#3b82f6', 0.35)}`
        : `0 6px 20px ${alpha(primary, 0.3)}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: theme.transitions.create(['transform', 'box-shadow'], { duration: 200 }),
    '&:active': {
      transform: 'translateX(-50%) scale(0.94)',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1.9rem',
    },
  };
}

export function getMobileFooterFabSlotSx() {
  return {
    width: MOBILE_FOOTER_FAB_SIZE,
    flexShrink: 0,
  };
}
